import { bus } from '../../utils'

export default {
  beforeDestroy () {
    bus.$off('show-lock-device')
  },
  computed: {
    id () {
      return this.info.id
    }
  },
  methods: {
    closePopup () {
      this.showModal = false
    },
    lockDevice (sn) {
      return this.$api.lockDevice(sn)
        .then(() => bus.$emit('update-locked-device-list', sn))
        .catch((error) => new Error(`Failed to delete device, please try again later (Error: ${JSON.stringify(error)})`))
    }
  },
  name: 'DeviceLock',
  data () {
    return {
      buttons: [
        {
          class: 'btn-close',
          id: 'Close',
          text: 'deviceLockDialogButtonCloseText',
          type: 'text',
          click: () => { this.closePopup() }
        },
        {
          id: 'Delete',
          text: 'deviceLockDialogButtonDeleteText',
          type: 'warning',
          click: () => {
            this.lockDevice(this.info.sn)
            this.closePopup()
          }
        }
      ],
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      info: {},
      showModal: false
    }
  },
  mounted () {
    bus.$on('show-lock-device', ({ show, info }) => {
      if (show) {
        this.showModal = true
      }

      if (info) {
        this.info = info
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceLock/DeviceLock.js